import http from "../http-common";

class PensumService {
  getAll(params = {}) {
    return http.get("/pensums", { params });
  }

  get(id) {
    return http.get(`/pensums/${id}`);
  }

  getByGrade(gradeId) {
    return http.get(`/pensums/grade/${gradeId}`);
  }

  getByGradeGrouped() {
    return http.get("/pensums/by-grade");
  }

  create(data) {
    return http.post("/pensums", data);
  }

  update(id, data) {
    return http.put(`/pensums/${id}`, data);
  }

  updateOrder(pensums) {
    return http.post("/pensums/update-order", { pensums });
  }

  delete(id) {
    return http.delete(`/pensums/${id}`);
  }

  getTrashed() {
    return http.get("/pensums/trashed/list");
  }

  restore(id) {
    return http.post(`/pensums/${id}/restore`);
  }
}

export default new PensumService();
